import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import Box from '@nubank/nuds-web/components/Box/Box';
import Typography from '@nubank/nuds-web/components/Typography/Typography';
import Image from '@nubank/nuds-web/components/Image/Image';
import { NuDsContext } from '@nubank/nuds-web/components/NuDSProvider/NuDSProvider';

import { StyledCenteredBox } from '../../styles/Box';

function SectionContact({ index }) {
  const { formatMessage } = useContext(NuDsContext);
  return (
    <Box
      tag="section"
      paddingBottom={{ xs: '12x', md: '20x' }}
    >
      <StyledCenteredBox>
        <Image
          altIntlKey="ACCOUNT.CONTACT.IMAGE_ALT"
          loading="lazy"
          srcSet={{
            xs: 'girl-holding-phone/girl-holding-phone@0.5x.jpg',
            md: 'girl-holding-phone/girl-holding-phone@tablet2x.jpg',
            lg: 'girl-holding-phone/girl-holding-phone@3x.jpg',
          }}
        />
      </StyledCenteredBox>
      <Box
        paddingHorizontal={{ xs: '6x', md: '12x', lg: 56 }}
        marginTop={{ xs: '8x', md: '12x', lg: '20x' }}
        display={{ lg: 'grid' }}
        gridTemplateColumns={{ lg: 'repeat(12,1fr)' }}
        gridColumnGap={{ lg: '8x' }}
      >
        <Box
          gridColumn={{ lg: '3 / 11' }}
          maxWidth={{ md: '570px', lg: 'none' }}
          marginHorizontal={{ md: 'auto' }}
        >
          <Typography
            variant="title"
            intlKey={`cms.accountPage.cardsArea[${index}].title`}
            marginBottom={{ xs: '6x' }}
            marginHorizontal={{ md: 'auto' }}
            maxWidth={{ xs: '12ch', lg: 'none' }}
            textAlign={{ md: 'center' }}
          />
          {formatMessage({
            id: `cms.accountPage.cardsArea[${index}.description]`,
          }, {
            p: props => <Typography marginHorizontal={{ md: 'auto' }} textAlign={{ md: 'center' }} variant="subtitle" {...props} />,
          })}
        </Box>
      </Box>
    </Box>
  );
}

SectionContact.propTypes = {
  index: PropTypes.number.isRequired,
};

export default React.memo(SectionContact);
